import React from 'react';

const SvgEvents = props => (
  <svg
    id="events_svg__Layer_1"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <style>{'.events_svg__cls-1{fill:#989898}'}</style>
    </defs>
    <path
      className="events_svg__cls-1"
      d="M19.24 4.19H16.4v-1a.7.7 0 00-.7-.71H8.38a.7.7 0 00-.7.7v1H4.76a.71.71 0 00-.71.71v15.89a.71.71 0 00.71.71h14.48a.71.71 0 00.71-.71V4.9a.71.71 0 00-.71-.71zm-10.15 0v-.27H15v2H9.09V4.19zm9.45 15.89H5.46V5.6h2.22v1a.7.7 0 00.7.7h7.31a.7.7 0 00.71-.7v-1h2.14z"
    />
    <path
      className="events_svg__cls-1"
      d="M16 9.69H8.1a.7.7 0 00-.7.7.7.7 0 00.7.71H16a.71.71 0 100-1.41zM16 13.17H8.1a.71.71 0 00-.71.71.7.7 0 00.71.7H16a.7.7 0 00.7-.7.71.71 0 00-.7-.71zM13.8 16.66H8.1a.7.7 0 00-.7.7.7.7 0 00.7.71h5.7a.71.71 0 100-1.41z"
    />
  </svg>
);

export default SvgEvents;
